<template>
  <div class="HeaderAdvertisementDetail">
    <div class="HeaderAdvertisementDetail__Header">
      <Header :title="$t('advertisement')" />
    </div>
    <div class="HeaderAdvertisementDetail__goBack" @click="goBack">
      <Icon name="keyboard-arrow-left" style="color: red" />
      <GoBack :cancel="$t('advertisement.go-back')" />
    </div>
  </div>
</template>

<script>
import { Card, Header } from '@/components';
import { Header as GoBack } from 'daas-components';
import Icon from '@/components/Icon';

export default {
  name: 'HeaderAdvertisementDetail',
  components: {
    Card,
    Icon,
    Header,
    GoBack,
  },
  methods: {
    goBack() {
      const params = this.$route.params.businessId;
      this.$router.push({ path: `/business/${params}` });
    },
  },
};
</script>

<style lang="scss">
.HeaderAdvertisementDetail {
  &__goBack {
    display: flex;
    align-items: center;
    cursor: pointer;
    text-transform: uppercase;
    width: 100%;
    justify-content: center;
  }
  &__Header {
    width: 100%;
    display: flex;
    justify-content: center;
  }
}
</style>
